module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "havHeader"
  }, _vm._l((_vm.getSortedDate), function(data) {
    return _c('li', {
      key: data.orderNumber,
      on: {
        "click": function($event) {
          return _vm.clickElement(data.route)
        }
      }
    }, [_vm._v(_vm._s(data.text))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa97b40e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/navHeader/NavHeader.vue
// module id = 44ae066e58e2aebef010
// module chunks = 0